import { stringDuckCreator } from '@atc/modular-redux';

export default stringDuckCreator({
    store: 'brand',
    initialState: 'atc',
});
